export default import.meta.ROLLUP_FILE_URL_CnGe1JO6;